var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"page"},[_c('due-tabs',{model:{value:(_vm.activeName),callback:function ($$v) {_vm.activeName=$$v},expression:"activeName"}}),_c('div',{staticClass:"content-box"},[_c('fast-edit-order')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }